<template>
    <div class="report-overview" v-loading="loading">
        <!--工具条-->
		<el-row class="ro-tool-bar">
			<el-button class="ro-btn" :loading="csvLoading" @click="getCSVData">
				下載報表
			</el-button>
			<downloadCsv ref="downloadCsv" :data = "csvData" 
            name = "data.csv" :labels="labels" style="display: none;"></downloadCsv>
		</el-row>
        <el-row v-for="(dep, index) in overview" :key="dep.depId" class="overview-table">
            <el-row v-if="index === 0" class="overview-title">
                <el-col :span="8" class="overview-col1">{{ dep.title }}</el-col>
                <el-col :span="4">部門人數</el-col>
                <el-col :span="3">使用人數</el-col>
                <el-col :span="3">使用率</el-col>
                <el-col :span="3">活躍人數</el-col>
                <el-col :span="3">活躍率</el-col>
            </el-row>
            <el-row v-else class="overview-title">
                <el-col :span="8" class="overview-col1">{{ dep.title }}</el-col>
            </el-row>
            <el-row v-for="actual_dep in dep.actual_dep" :key="actual_dep.id" class="overview-data">
                <el-col :span="8" class="overview-col1">{{ actual_dep.name }}</el-col>
                <el-col :span="4">{{ actual_dep.members }}</el-col>
                <el-col :span="3">{{ actual_dep.usage_members }}</el-col>
                <el-col :span="3">{{ actual_dep.usage_rate }}%</el-col>
                <el-col :span="3">{{ actual_dep.active_members }}</el-col>
                <el-col :span="3">{{ actual_dep.active_rate }}%</el-col>
            </el-row>
        </el-row>
    </div>
</template>

<script>
import API from '../../api/api';
export default {
    name: 'ReportOverview',
    data() {
        return {
            loading: false,
            csvLoading: false,
            csvData:[],
            labels: {
                name: "",
                members: "部門人數",
                usage_members: "使用人數",
                usage_rate: "使用率",
                active_members: "活躍人數",
                active_rate: "活躍率", 
            },
            overview: [],
        }
    },
    watch: {
        '$store.state.userInfoReady': {
            immediate: true,
            handler(val) {
                if (val) {
                    this.init();
                }
            }
        },
        '$store.state.report.dateRange': {
            immediate: false,
            handler(val) {
                //reload
                if (val && this.$store.state.report.dateRange.length > 1) {
                    if (this.$store.state.report.dateRange[0] instanceof Date) {
                        this.$store.state.report.dateRange[0] = this.$store.state.report.dateRange[0].getTime();
                    }
                    if (this.$store.state.report.dateRange[1] instanceof Date) {
                        this.$store.state.report.dateRange[1] = this.$store.state.report.dateRange[1].getTime();
                    }
                    this.reloadStatistics();
                }
            }
        },
    },
    methods: {
        init() {
            this.reloadStatistics();
        },
        reloadStatistics() {
            this.loading = true;
            this.overview.splice(0);
            let startTime = null;
            let endTime = null;
            if (this.$store.state.report.dateRange.length > 1) {
                startTime = this.$store.state.report.dateRange[0];
                endTime = this.$store.state.report.dateRange[1];
            }
            API.getStatistics({
                startTime: startTime,
                endTime: endTime,
			}).then((response) => {
                if(response.status) {
                    redirectLogin(response.data);
                } else {
                    for (let i = 0; i < response.result.length; i++) {
                        let dep = this.overview.find(x => x.depId === response.result[i].dep.id);
                        if(dep) {
                            dep.actual_dep.push(this.getActualDepObj(response.result[i]));
                        } else {
                            let item = {
                                depId: response.result[i].dep.id,
                                title: response.result[i].dep.title,
                                actual_dep: [this.getActualDepObj(response.result[i])],
                            }
                            this.overview.push(item);
                        }
                    }
                }
                this.loading = false;
            });
        },
        getActualDepObj(rawData) {
            let members = rawData.number + rawData.exclude_number;
            let membersStr = members.toString();
            if (rawData.exclude_number > 0) {
                membersStr += "(" + rawData.exclude_number + "不統計)";
            }
            return {
                id: rawData.id,
                name: rawData.name,
                members: membersStr,
                usage_members: rawData.usage,
                usage_rate: rawData.usage_percent,
                active_members: rawData.activity,
                active_rate: rawData.activity_percent,
            };
        },
        getCSVData() {
            this.csvLoading = true;
            this.csvData.splice(0);
            
            for (let i = 0; i < this.overview.length; i++) {
                let item = {};
                if (i === 0) {
                    this.labels.name = this.overview[i].title;
                } else {
                    item.name = this.overview[i].title
                    this.csvData.push(item);
                }
                
                for (let j = 0; j < this.overview[i].actual_dep.length; j++) {
                    let item = {};
                    item.name = this.overview[i].actual_dep[j].name;
                    item.members = this.overview[i].actual_dep[j].members;
                    item.usage_members = this.overview[i].actual_dep[j].usage_members;
                    item.usage_rate = this.overview[i].actual_dep[j].usage_rate + "%";
                    item.active_members = this.overview[i].actual_dep[j].active_members;
                    item.active_rate = this.overview[i].actual_dep[j].active_rate + "%";
                    this.csvData.push(item);
                }
            }
            
            this.$refs.downloadCsv.generate();
			this.csvLoading = false;
        },
    },
}
</script>

<style lang="scss">
.report-overview {

    .ro-tool-bar {
        background: #FFFFFF;
        height: 48px;

        .ro-btn {
            display: inline;
            float: right;
			background: #2E90F4;
			border-radius: 2px;
			color: #fff;
			font-size: 14px;
			height: 36px;
			border: none;
            margin-top: 6px;
            margin-right: 12px;
		}

		.ro-btn:hover {
    		background: #42A0FF;
		}
    }

    .overview-table {
        line-height: 48px;

        .overview-title {
            background-color: #F7F7F7;
            font-weight: 500;
            border:  1px solid #EEE ;
        }

        .overview-data {
            background: white;
            border:  1px solid #EEE ;
            border-top: 0px;
        }

        .overview-col1 {
            padding-left: 10px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// ReportOverview.vue?d1234a70